import { Button, ButtonProps } from '@mui/material';

import { useToast } from '../communication/Toast';

interface DisabledButtonProps {
    children: React.ReactNode;
    disableReason: string;
    buttonProps: ButtonProps;
}

export const DisabledButton = ({ children, buttonProps, disableReason }: DisabledButtonProps) => {
    const [Toast, showToast] = useToast();

    const handleWrapperClick = (e: React.MouseEvent<HTMLSpanElement>) => {
        if (buttonProps.disabled) {
            e.preventDefault();
            e.stopPropagation();
            showToast({
                message: disableReason,
                severity: 'warning',
            });
        } else {
            buttonProps.onClick?.(e as unknown as React.MouseEvent<HTMLButtonElement>);
        }
    };

    return (
        <>
            <span
                role="button"
                tabIndex={0}
                aria-disabled="true"
                onClick={handleWrapperClick}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        handleWrapperClick(e as unknown as React.MouseEvent<HTMLSpanElement>);
                    }
                }}
                style={{ display: 'inline-block', cursor: 'not-allowed', outline: 'none' }}
            >
                <Button variant="contained" disabled {...buttonProps}>
                    {children}
                </Button>
            </span>
            <Toast />
        </>
    );
};
